import { render, staticRenderFns } from "./salary-upload.vue?vue&type=template&id=73a1fb84&scoped=true&"
import script from "./salary-upload.vue?vue&type=script&lang=js&"
export * from "./salary-upload.vue?vue&type=script&lang=js&"
import style0 from "./salary-upload.vue?vue&type=style&index=0&id=73a1fb84&prod&scoped=true&lang=scss&"
import style1 from "./salary-upload.vue?vue&type=style&index=1&id=73a1fb84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1fb84",
  null
  
)

export default component.exports